import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Hilton Analytica</h4>
          <p>
            Industry-leading purity analysis for research-use-only peptides with exceptional speed and accuracy.
          </p>
          <div className="footer-contact-info">
            <p><strong>Location:</strong></p>
            <p>Hilton Analytica</p>
            <p>Unit 12, Skyport Dr</p>
            <p>West Drayton UB7 0LB</p>
            <p>United Kingdom</p>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/request">Submit Samples</Link></li>
            <li><Link to="/search">COA Lookup</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact</h4>
          <div className="footer-contact-info">
            <p>Email: info@hiltonanalytica.co.za</p>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p className="footer-copyright">
          &copy; {currentYear} Hilton Analytica. All rights reserved.
        </p>
        <p className="footer-disclaimer">
          The products and services offered on this website are intended for research use only 
          and are not for human consumption, clinical, diagnostic, or therapeutic use.
        </p>
      </div>
    </footer>
  )
}

export default Footer